import { createSlice, createSelector } from "@reduxjs/toolkit";
import { coreApi } from "api/core";
import { setShowMessage } from "redux/slices/uiSlice";

const baseUrl = "/suppliers";

const initialState = {
  suppliers: [],
  supplier: {},
  timestamp: null,
  loading: false,
};

const suppliersSlice = createSlice({
  name: "suppliers",
  initialState,
  reducers: {
    setSuppliers: (state, action) => {
      state.suppliers = action.payload;
      state.timestamp = Date.now();
    },
    setSupplier: (state, action) => {
      state.supplier = action.payload;
    },
    setSuppliersLoading: (state) => {
      state.loading = true;
    },
    setSuppliersReady: (state) => {
      state.loading = false;
    },
  },
});

export const {
  setSuppliers,
  setSupplier,
  setSuppliersLoading,
  setSuppliersReady,
} = suppliersSlice.actions;

export default suppliersSlice.reducer;

export const getSuppliers = () => async (dispatch) => {
  dispatch(setSuppliersLoading());
  try {
    const data = await coreApi.fetch(`${baseUrl}/get-suppliers/`);
    dispatch(setSuppliers(data));
    return data;
  } catch (err) {
    console.error(err);
  } finally {
    dispatch(setSuppliersReady());
  }
};

export const getAllSuppliers = () => async (dispatch) => {
  dispatch(setSuppliersLoading());
  try {
    const data = await coreApi.fetch(`${baseUrl}/all`);
    dispatch(setSuppliers(data));
    return data;
  } catch (err) {
    console.error(err);
  } finally {
    dispatch(setSuppliersReady());
  }
};

export const getSupplierById = (id) => async (dispatch) => {
  dispatch(setSuppliersLoading());
  try {
    const data = await coreApi.fetch(`${baseUrl}/${id}`);
    dispatch(setSupplier(data));
    return data;
  } catch (err) {
    console.error(err);
  } finally {
    dispatch(setSuppliersReady());
  }
};
export const editSupplier = (id, payload) => async (dispatch) => {
  dispatch(setSuppliersLoading());

  try {
    const url = baseUrl + `/${id}`;
    const res = await coreApi.put(url, payload);
    dispatch(
      setShowMessage({
        description: "Supplier updated successfully",
        type: "success",
      })
    );
    return res;
  } catch (err) {
    if (err.response?.status === 409) {
      dispatch(
        setShowMessage({
          description: "Supplier already exists",
          type: "error",
        })
      );
    } else {
      dispatch(
        setShowMessage({
          description: "Failed to update supplier",
          type: "error",
        })
      );
    }
  } finally {
    dispatch(setSuppliersReady());
  }
};
export const createSupplier = (payload) => async (dispatch) => {
  dispatch(setSuppliersLoading());
  try {
    const res = await coreApi.post(baseUrl, payload);
    dispatch(
      setShowMessage({
        description: "Supplier created successfully",
        type: "success",
      })
    );
    return res;
  } catch (err) {
    if (err.response?.status === 409) {
      dispatch(
        setShowMessage({
          description: "Supplier already exists",
          type: "error",
        })
      );
    } else {
      dispatch(
        setShowMessage({
          description: "Failed to create supplier",
          type: "error",
        })
      );
    }
  } finally {
    dispatch(setSuppliersReady());
  }
};

// Selectors
const suppliersSelector = ({ suppliers }) => suppliers?.suppliers || [];
const supplierSelector = ({ suppliers }) => suppliers?.supplier || {};
const suppliersStatusSelector = ({ suppliers }) => suppliers.loading;

export const selectSuppliers = createSelector(suppliersSelector, (data) => data);
export const selectSupplier = createSelector(supplierSelector, (data) => data);
export const selectSuppliersStatus = createSelector(suppliersStatusSelector, (loading) => loading);
